/* eslint-disable react/prop-types */

import React, { useRef, useEffect } from 'react';
import Flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css'; // Local Flatpickr styles
import { Col, Row } from 'react-bootstrap';
import { format } from 'date-fns';
import { MdOutlineRefresh } from 'react-icons/md';

const RangeDatePicker = ({ onDateChange, noLabel, styleWidth }) => {
  const datePickerRef = useRef(null);
  const flatpickrInstance = useRef(null); // Store the Flatpickr instance

  // Default dates using date-fns
  const defaultStartDate = new Date(2024, 10, 1); // Nov 1, 2024
  const defaultEndDate = new Date(); // Today
  useEffect(() => {
    if (datePickerRef.current) {
      flatpickrInstance.current = Flatpickr(datePickerRef.current, {
        mode: 'range',
        dateFormat: 'd/m/y', // Internal format for API or backend
        altInput: true, // Use an alternate input for display
        altFormat: 'M d, Y', // Custom format: "Feb 01, 2003"
        disableMobile: true, // Disable mobile date picker
        maxDate: new Date(),
        onChange: selectedDates => {
          // Extract the start and end dates from the selected range
          const [start, end] = selectedDates;
          // Pass them to the parent component using the callback
          onDateChange(start, end);
        }
      });
    }
  }, []);

  // Function to clear the selected dates
  const clearDates = () => {
    if (flatpickrInstance.current) {
      flatpickrInstance.current.clear(); // Clear the selected range
      onDateChange('', ''); // Pass null values to the parent to reset the state
    }
  };

  return (
    <div className="form-group">
      {noLabel ? null : (
        <label htmlFor="rangeDatePicker">Select Date Range</label>
      )}
      <Row className="d-flex align-items-center pb-2">
        <Col className="d-flex align-items-center justify-content-start pr-0">
          <input
            ref={datePickerRef}
            id="rangeDatePicker"
            className="form-control"
            type="text"
            placeholder={`${format(
              defaultStartDate,
              'MMM dd, yyyy'
            )} to ${format(defaultEndDate, 'MMM dd, yyyy')}`}
          />
          <button
            type="button"
            onClick={clearDates}
            className="btn btn-secondary mt-0"
            style={{ marginLeft: '12px' }}
          >
            <MdOutlineRefresh />
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default RangeDatePicker;
